import { createApp } from 'vue'
import App from './App.vue'
import emailjs from '@emailjs/browser'

// Initialize EmailJS
emailjs.init('YOUR_EMAILJS_USER_ID') // Replace with your actual EmailJS User ID

createApp(App).mount('#app')
